// libs
import { createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  getListSpotActionsRequest: ['params'],
  getListSpotActionsSuccess: ['data'],
  getListSpotActionsFailed: ['error']
});
